"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
/** @jsx jsx */
var React = __importStar(require("react"));
var core_1 = require("@emotion/core");
var Theme_1 = require("../Theme");
exports.flexFooterStyling = function (theme) {
    return core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: flex;\n        min-height: 100vh;\n        flex-direction: column;\n        background-color: ", ";\n    "], ["\n        display: flex;\n        min-height: 100vh;\n        flex-direction: column;\n        background-color: ", ";\n    "])), Theme_1.applyTheme(theme, function (t) { return t.colors.primaryBackground; }));
};
exports.childrenStyling = function (theme) {
    return core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        flex: 1;\n    "], ["\n        flex: 1;\n    "])));
};
var Page = /** @class */ (function (_super) {
    __extends(Page, _super);
    function Page() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Page.prototype.render = function () {
        var _this = this;
        return (core_1.jsx("div", { css: function (t) { return [exports.flexFooterStyling(t), _this.props.pageStyling !== undefined ? _this.props.pageStyling(t) : undefined]; } },
            core_1.jsx("div", { css: exports.childrenStyling },
                this.props.menu,
                this.props.children),
            core_1.jsx("div", null, this.props.footer)));
    };
    return Page;
}(React.Component));
exports["default"] = Page;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Page.js.map